// src/components/widgets/link-textfield.js
import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Link } from '@mui/material';

const LinkTextField = ({ value, onClick, sx={} }) => {
  return (
    <Stack direction="row" alignItems="center">
      <Link
        component="button"
        variant="subtitle2"
        onClick={onClick}
        underline="hover"
        sx={{ color: 'inherit', ...sx }}
      >
        {value}
      </Link>
    </Stack>
  );
};

LinkTextField.propTypes = {
  value: PropTypes.node,
  onClick: PropTypes.func,
  sx: PropTypes.object,
};


export default LinkTextField;
